// src/components/Table/index.tsx

import React from 'react';
import { TableContainer, TableWrapper, StyledTable } from './styles';
import { TableHeader } from './TableHeader';
import { TableBody } from './TableBody';
import { TableProps } from '../../types/table';

export const Table = <T extends { id?: string | number }>({
    columns,
    data,
    loading = false,
    showActions = false,
    onRowClick,
    emptyMessage,
    className,
    rowClickable = false
}: TableProps<T>) => {
    return (
        <TableContainer $className={className}>
            <TableWrapper>
                <StyledTable>
                    <TableHeader columns={columns} showActions={showActions} />
                    <TableBody
                        columns={columns}
                        data={data}
                        showActions={showActions}
                        onRowClick={onRowClick}
                        emptyMessage={emptyMessage}
                        loading={loading}
                        rowClickable={rowClickable}
                    />
                </StyledTable>
            </TableWrapper>
        </TableContainer>
    );
};